import React, { useState } from 'react'
import { Box, InputBase, IconButton, Typography, alpha } from '@mui/material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// LAP — « Life Intelligence se retrouve on top of the feed » (demande
// Alexis). Avant : bouton dans le header qui navigue vers /life-intelligence.
// Maintenant : barre de saisie posée au-dessus du feed. On ne duplique pas
// le moteur de chat (ConseillerChat) sur l'accueil — on envoie la question
// vers la page plein écran via `seedPrompt`, mécanisme déjà géré par
// LifeIntelligencePage (location.state.seedPrompt → autoSendPrompt).
export default function LifeIntelligenceBar() {
  const { t } = useTranslation('layout')
  const navigate = useNavigate()
  const [value, setValue] = useState('')

  const goToChat = (seedPrompt) => {
    navigate('/life-intelligence', { state: seedPrompt ? { seedPrompt } : undefined })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    goToChat(value.trim())
  }

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        pl: 2,
        borderRadius: '16px',
        background: 'linear-gradient(135deg, rgba(102,126,234,0.16) 0%, rgba(118,75,162,0.16) 100%)',
        border: '1px solid rgba(102,126,234,0.35)',
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: '12px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <AutoAwesomeIcon sx={{ color: '#fff', fontSize: 20 }} />
      </Box>

      <InputBase
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t('dashboard.lifeIntelligenceBarPlaceholder', {
          defaultValue: "Demandez n'importe quoi à Life Intelligence…",
        })}
        sx={{
          flex: 1,
          color: '#E0E0E0',
          fontSize: '0.95rem',
          '& input::placeholder': { color: alpha('#E0E0E0', 0.55) },
        }}
      />

      <Typography
        onClick={() => goToChat('')}
        sx={{
          display: { xs: 'none', sm: 'block' },
          color: alpha('#E0E0E0', 0.55),
          fontSize: '0.78rem',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          '&:hover': { color: '#E0E0E0' },
        }}
      >
        {t('lifeIntelligence.pageTitle', { defaultValue: 'Life Intelligence' })}
      </Typography>

      <IconButton
        type="submit"
        disabled={!value.trim()}
        sx={{
          bgcolor: value.trim() ? 'rgba(102,126,234,0.3)' : 'transparent',
          color: '#fff',
          '&:hover': { bgcolor: 'rgba(102,126,234,0.45)' },
          '&.Mui-disabled': { color: alpha('#E0E0E0', 0.3) },
        }}
        aria-label={t('dashboard.lifeIntelligenceBarCta', { defaultValue: 'Demander' })}
      >
        <ArrowForwardRoundedIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}
